import { Pipe, PipeTransform } from '@angular/core';
import { StudentEksportStatus } from '@interfaces/polon/enums/eksport-polon-student-historia-status/eksport-polon-student-historia-status';

@Pipe({
  name: 'statusEksportuStudenta',
})
export class StatusHEksportStudentPipe implements PipeTransform {
  transform(value: StudentEksportStatus): string {
    const { Sukces, Blad } = StudentEksportStatus;

    switch (value) {
      case Sukces:
        return 'bg-success';
      case Blad:
        return 'bg-error';
      default:
        return 'bg-warning';
    }
  }
}
